import state from "../store";

import {postRequest, getRequest} from './networkService';

export function validateToken() {
    let token = localStorage.getItem('token');
    let expires = localStorage.getItem('expires');

    if (token && expires) {
        if (new Date(expires) > new Date()) {
            return true;
        }
    }

    return false;
}

export async function Login(email, password) {
    let response = await postRequest('user/login', {email, password}, null, false);

    if (response.ok) {
        let responseJson = await response.json();
        localStorage.setItem('token', responseJson.token);
        localStorage.setItem('name', responseJson.name);
        localStorage.setItem('expires', responseJson.expires);

        state.isLoggedIn = true;

        return responseJson;
    } else {
        throw new Error('Login failed');
    }
}

export async function GetUser(context) {
    let response = await getRequest('user/me', context);
    return response.json();
}

export async function UpdateUser(context, name, emailAddress, sendEmail = true) {
    let response = await postRequest('user/me', {
        name,
        emailAddress,
        sendEmail
    }, context);

    if (response.ok) {
        let responseJson = await response.json();
        localStorage.setItem('name', responseJson.name);
        return responseJson;
    } else {
        let responseJson = await response.json();
        throw responseJson;
    }
}